export default "__VITE_ASSET__HXmT2NJv__"